// extracted by mini-css-extract-plugin
export default {"guidelinesContainer":"ThreadColorGuidelines_guidelinesContainer__y0Wd+","tooltip":"ThreadColorGuidelines_tooltip__38zNC"};